// extracted by mini-css-extract-plugin
export default {"prompt":"progressGate_prompt__WWst8"};